import React, { Component } from 'react';
import { withRouter } from "react-router-dom";


class Banner extends Component {

    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }


    handleClick(event) {
        event.preventDefault();
        let path = '';
        switch (event.target.id) {

            case 'supportBtn':
                path = '/support-request';
                this.props.history.replace(path);
                break;
            default:
                break;
        }
    }

    render() {

        var headText = this.props.headText;
        var subHeadText = this.props.subHeadText;
        var subBoldText = this.props.subBoldText;
        var img = this.props.img;

        return (
            <div>
                <div className="main-container coverImage">
                    <img src={require('../img/banner/' + img)} height={450} width='100%' />
                    <a id="supportBtn" onClick={this.handleClick} className="btn btn-default need">NEED HELP NOW  <span className="glyphicon glyphicon-play"></span></a><br />
                    <br />
                    <div className="container textInCover">
                        <div className="row">

                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <h2 className="land">
                                    {headText}
                                </h2>
                                <p className="landsub">
                                    {subHeadText}
                                    <br />
                                    <br />
                                    <strong>
                                        {subBoldText}
                                    </strong>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Banner);


// WEBPACK FOOTER //
// ./src/components/Banner.js